export default __webpack_public_path__ + "static/media/search-header.3d210d2f.svg";